import * as clientErrTypes from 'config/clientErrorTypes';
import { generateApiErrObj } from 'client/hooks/useClientErrorHandler';
import { getUserPasscodeStatus } from 'api/client';
import { getPasscodeErrorType, errorTypes } from 'config/passcode';

export default async function checkEntryNeedPasscode({
    promoUUID,
    entryUUID,
    enablePasscodeVerify
} = {}) {
    if (!enablePasscodeVerify) {
        return false;
    }
    const resp = await getUserPasscodeStatus({
        promoUUID,
        entryUUID
    });
    if (resp.httpStatus === 200) {
        return false;
    } else if (getPasscodeErrorType(resp) === errorTypes.ENTRY_NEED_PASSCODE) {
        return true;
    } else {
        throw generateApiErrObj(resp, clientErrTypes.CHECK_PASSCODE_STATUS);
    }
}
